
export default {
    name: 'coursestoremanagement',
    //进入的是什么管理系统
    data() {
        return {
            // 店铺的名字
            store: '',
            // 店铺id
            shop_id: this.$store.state.shopId,
            // 权限对象
            authorizationObject: {},
            // 权限用户的名字
            name: '',
            // 标题
            title: '',
            // 控制修改密码对话框的显示
            dialogVisible: false,
            // 旧密码
            oldPwd: '',
            // 新密码
            newPwd: '',
            // 确认密码
            rePwd: '',
        }
    },
    methods: {
        toclassorder: function () {
            this.$router.push({
                path: '/classorder',
            })
        },
        //回到个人中心
        loginOut: function () {
            this.$router.push({
                path: '/personalcenter'
            })
        },

        // 获取权限用户信息
        getInfo() {
            this.$post('authority_management_user/get_info', {
                token: sessionStorage.getItem('authid')
            }).then(res => {
                this.name = res.data.result.name
            })
        },

        // 退出登录
        loginOut() {
            this.$confirm('确认退出登录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                sessionStorage.removeItem('authid')
                sessionStorage.removeItem('authorizationObject')
                this.$store.state.activity_management = null
                this.$router.push({
                    path: '/authority_management_login'
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消退出登录'
                })
            })
        },

        // 修改密码
        changePwd() {
            let { oldPwd, newPwd, rePwd } = this;
            // 验证
            if (oldPwd == '') {
                this.$message.error('请输入旧密码');
                return;
            } else if (newPwd == '') {
                this.$message.error('请输入新密码');
                return;
            } else if (rePwd == '') {
                this.$message.error('请输入确认密码');
                return;
            } else if (newPwd != rePwd) {
                this.$message.error('两次密码不一致');
                return;
            } else if (newPwd.length < 4) {
                this.$message.error('新密码长度至少四位');
            }
            this.confirmChangePwd();
        },

        // 确定修改密码
        confirmChangePwd() {
            this.$post('/authority_management_user/editPassword', {
                token: this.$store.state.authority_management,
                oldPassword: this.oldPwd,
                newPassword: this.newPwd
            }).then(res => {
                if (res.data.status == 'success') {
                    this.$message.success('修改成功');
                    this.dialogVisible = false;
                } else if (res.data.status == 'fail') {
                    this.$message.error(res.data.errorMsg[0]);
                } else {
                    this.$message.error('修改失败，请稍后重试！');
                }
            })
        }
    },
    created() {
        this.$store.state.store.id == 107 ? this.title = '郑州人才后台管理' : this.title = '后台管理';
        document.title = this.title;

        this.manageType = this.$route.query.type;

        // 从缓存中获取用户权限信息
        this.authorizationObject = JSON.parse(sessionStorage.getItem('authorizationObject'))

        // 获取权限用户信息
        this.getInfo()

    }
}
